import { render } from "./FormUbahLokasi.vue?vue&type=template&id=836071c0"
import script from "./FormUbahLokasi.vue?vue&type=script&lang=js"
export * from "./FormUbahLokasi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__